(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blogs-recipes"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const container_blogs = document.getElementById('blogs-container');
    const leftArrow_blogs = document.querySelector('#blog_leftArrow');
    const rightArrow_blogs = document.querySelector('#blog_rightArrow');
    const cardWidth = 294 + 16; // card width + margin-right
    let currentPosition_blogs = 0;

    function updateSliderPosition() {
      container_blogs.style.transform = `translateX(${currentPosition_blogs}px)`;
    }

    leftArrow_blogs.addEventListener('click', () => {
      currentPosition_blogs = Math.min(currentPosition_blogs + cardWidth, 0);
      updateSliderPosition();
    });

    rightArrow_blogs.addEventListener('click', () => {
      const containerWidth = container_blogs.offsetWidth;
      const scrollWidth = container_blogs.scrollWidth;
      const maxScroll = scrollWidth - containerWidth;
      currentPosition_blogs = Math.max(currentPosition_blogs - cardWidth, -maxScroll);
      updateSliderPosition();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-get-started-slider"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined') {
      new Swiper('.get-started-swiper.swiper-container', {
        loop: true,
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-sub-dropdowns"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

    dropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', function () {
        const parent = this.parentElement;
        const iconOpen = this.querySelector('.toggle-icon');
        const iconClose = this.querySelector('.toggle-icon-close');
        const isActive = parent.classList.contains('active');

        if (isActive) {
          iconOpen.style.display = 'block';
          iconClose.style.display = 'none';
        } else {
          iconOpen.style.display = 'none';
          iconClose.style.display = 'block';
        }

        parent.classList.toggle('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-sub-product-slider"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.ebd-sub-product-slider .swiper-container', {
      slidesPerView: 1.05,
      spaceBetween: 15,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        450: {
          slidesPerView: 1.25,
        },
        650: {
          slidesPerView: 1.65,
        },
        800: {
          slidesPerView: 2.05,
          spaceBetween: 20,
        },
        1100: {
          slidesPerView: 2.5,
        },
        1400: {
          slidesPerView: 3.05,
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-sub-review-slider"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.ebd-sub-review-slider .swiper-container', {
      slidesPerView: 1.05,
      spaceBetween: 15,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        450: {
          slidesPerView: 1.25,
        },
        650: {
          slidesPerView: 1.65,
          spaceBetween: 25,
        },
        800: {
          slidesPerView: 2.05,
          spaceBetween: 20,
        },
        1100: {
          slidesPerView: 3.5,
        },
        1400: {
          slidesPerView: 4.05,
          spaceBetween: 25,
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-get-support"] && !window.DesignMode) return;
  try {
    
  var supportSwiper = new Swiper('.supportSwiper', {
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"><span class="progress"></span></span>';
      },
    },
    on: {
      slideChangeTransitionStart: function (swiper) {
        const bullets = document.querySelectorAll('.swiper-pagination-bullet span.progress');
        bullets.forEach((bullet) => (bullet.style.width = '0')); // Reset all bullets
        const activeBullet = bullets[swiper?.realIndex];
        if (activeBullet) activeBullet.style.width = '100%'; // Animate the active bullet
      },
    },
  });

  document.querySelectorAll('.supportSwiper .swiper-pagination-bullet span.progress')[0].style.width = '100%';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lsf-difference"] && !window.DesignMode) return;
  try {
    
  var swiper = new Swiper('.lsf-difference-slider', {
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.lsf-difference-pagination',
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + /*(index + 1)*/ ' ' + '</span>';
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mush-lp-dropdowns"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

    dropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', function () {
        const dropdownContent = this.nextElementSibling;

        this.classList.toggle('active');
        dropdownContent.classList.toggle('open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mush-lp-recipes"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const toggles = document.querySelectorAll('.mushroom-lp-recipes .toggle');
    const recipes = document.querySelectorAll('.mushroom-lp-recipes .recipe');

    toggles.forEach((toggle, index) => {
      toggle.addEventListener('click', function() {
        // Remove active class from all toggles and recipes
        toggles.forEach(t => t.classList.remove('active'));
        recipes.forEach(r => r.classList.remove('active'));

        // Add active class to the clicked toggle and corresponding recipe
        toggle.classList.add('active');
        recipes[index].classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ohana-FAQs"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqContainer = document.getElementById('faq-container');
    let openIndex = -1;

    faqContainer.addEventListener('click', function (event) {
      const question = event.target.closest('.faq-question');
      if (question) {
        const index = parseInt(question.dataset.index);
        const answer = question.nextElementSibling;
        const plusMinus = question.querySelector('span');

        if (openIndex === index) {
          answer.style.display = 'none';
          question.classList.remove('text-brand-red');
          plusMinus.textContent = '+';
          openIndex = -1;
        } else {
          if (openIndex !== -1) {
            const openQuestion = faqContainer.querySelector(`[data-index="${openIndex}"]`);
            const openAnswer = openQuestion.nextElementSibling;
            const openPlusMinus = openQuestion.querySelector('span');
            openAnswer.style.display = 'none';
            openQuestion.classList.remove('text-brand-red');
            openPlusMinus.textContent = '+';
          }

          answer.style.display = 'block';
          question.classList.add('text-brand-red');
          plusMinus.textContent = '−';
          openIndex = index;
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ohana-ingredients"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const ingredientSelect = document.getElementById('ingredient-select');
    const ingredientButtons = document.querySelectorAll('.ingredient-button');
    const ingredientContents = document.querySelectorAll('.ingredient-content');

    function setActiveIngredient(index) {
      ingredientButtons.forEach((button) =>
        button.classList.remove('active', 'bg-[#D8E3E8]', 'font-semibold', 'border-2', 'border-[#3A758A]', 'text-black')
      );
      ingredientButtons[index].classList.add(
        'active',
        'bg-[#D8E3E8]',
        'font-semibold',
        'border-2',
        'border-[#3A758A]',
        'text-black'
      );

      ingredientContents.forEach((content) => content.classList.add('hidden'));
      ingredientContents[index].classList.remove('hidden');
    }

    ingredientSelect.addEventListener('change', function () {
      setActiveIngredient(parseInt(this.value));
    });

    setActiveIngredient(0);

    ingredientButtons.forEach((button) => {
      button.addEventListener('click', function () {
        setActiveIngredient(parseInt(this.getAttribute('data-index')));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ohana-media-grid"] && !window.DesignMode) return;
  try {
    
  class ScrollHandler {
    constructor() {
      this.init();
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.addEventListeners();
    }

    init() {
      try {
        // Get required elements
        this.headerElement = document.querySelector('#desktop-nav');
        this.outerContainer = document.getElementById('outer-container');
        this.leftColumn = document.getElementById('left-column');
        this.rightColumn = document.getElementById('right-column');
        this.content = document.getElementById('right-content');

        if (!this.validateElements()) {
          throw new Error('Required elements not found');
        }

        // Initialize state
        this.state = {
          headerHeight: this.headerElement.offsetHeight,
          windowHeight: window.innerHeight,
          scrollPosition: window.scrollY,
          contentWidth: this.content.offsetWidth,
          lastScrollTop: 0,
          ticking: false,
          isSticky: false,
          stickyType: null, // 'top' or 'bottom'
        };

        this.updateDimensions();
      } catch (error) {
        console.error('ScrollHandler initialization failed:', error);
      }
    }

    validateElements() {
      return this.headerElement && this.outerContainer && this.leftColumn && this.rightColumn && this.content;
    }

    updateDimensions() {
      const rect = this.content.getBoundingClientRect();
      this.state = {
        ...this.state,
        windowHeight: window.innerHeight,
        contentWidth: this.content.offsetWidth,
        contentHeight: this.content.offsetHeight,
        contentTop: rect.top + window.scrollY,
        containerHeight: this.outerContainer.offsetHeight,
        leftColumnHeight: this.leftColumn.offsetHeight,
        containerTop: this.outerContainer.offsetTop,
      };
    }

    handleScroll() {
      if (this.state.ticking) return;

      this.state.ticking = true;
      requestAnimationFrame(() => {
        try {
          const currentScroll = window.scrollY;
          const scrollingDown = currentScroll > this.state.lastScrollTop;

          this.updateScrollState(currentScroll, scrollingDown);

          this.state.lastScrollTop = currentScroll;
          this.state.ticking = false;
        } catch (error) {
          console.error('Scroll handling error:', error);
          this.state.ticking = false;
        }
      });
    }

    updateScrollState(currentScroll, scrollingDown) {
      // Get current positions
      const contentRect = this.content.getBoundingClientRect();
      const leftColumnRect = this.leftColumn.getBoundingClientRect();
      const containerRect = this.outerContainer.getBoundingClientRect();

      // Calculate thresholds
      const contentTop = this.state.contentTop;
      const windowBottom = currentScroll + this.state.windowHeight;
      const containerBottom = this.state.containerTop + this.state.containerHeight;
      const contentBottom = contentTop + this.state.contentHeight;

      // Check if content should be sticky at top
      if (!scrollingDown) {
        if (currentScroll <= contentRect.top + 300) {
          this.stickyToTop();
          //console.log(contentTop, this.state.containerTop);
        }

        if (currentScroll < this.state.headerHeight) {
          this.fixToTop();
        }
      }
      // Check if content should be sticky at bottom
      else {
        if (windowBottom >= contentBottom && windowBottom < containerBottom) {
          this.stickyToBottom();
        } else if (windowBottom >= containerBottom) {
          this.fixToBottom();
        }
      }
    }

    stickyToTop() {
      if (this.state.stickyType !== 'top') {
        this.content.style.cssText = `
        position: fixed;
        top: ${this.state.headerHeight + 35}px;
        width: ${this.state.contentWidth}px;
        transition: transform 0.3s ease-out;
      `;

        this.state.isSticky = true;
        this.state.stickyType = 'top';
      }
    }

    stickyToBottom() {
      if (this.state.stickyType !== 'bottom') {
        this.content.style.cssText = `
        position: fixed;
        bottom: 0;
        width: ${this.state.contentWidth}px;
        transition: transform 0.3s ease-out;
      `;
        this.state.isSticky = true;
        this.state.stickyType = 'bottom';
      }
    }

    fixToTop() {
      if (this.state.isSticky) {
        this.content.style.cssText = `
        position: relative;
        top: 0;
      `;
        this.state.isSticky = false;
        this.state.stickyType = null;
      }
    }

    fixToBottom() {
      if (this.state.isSticky) {
        this.content.style.cssText = `
        position: absolute;
        bottom: 0;
      `;
        this.state.isSticky = false;
        this.state.stickyType = null;
      }
    }

    handleResize() {
      this.updateDimensions();
      this.handleScroll();
    }

    addEventListeners() {
      window.addEventListener('scroll', this.throttle(this.handleScroll, 16));
      window.addEventListener('resize', this.debounce(this.handleResize, 250));
    }

    throttle(func, limit) {
      let inThrottle;
      return (...args) => {
        if (!inThrottle) {
          func.apply(this, args);
          inThrottle = true;
          setTimeout(() => (inThrottle = false), limit);
        }
      };
    }

    debounce(func, wait) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    destroy() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', () => {
    try {
      if (window.innerWidth > 768) {
        const scrollHandler = new ScrollHandler();
        // Cleanup on page unload
        window.addEventListener('unload', () => scrollHandler.destroy());
      }
    } catch (error) {
      //console.error('Failed to initialize ScrollHandler:', error);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    const videoContainers = document.querySelectorAll('.video-container-inline');
    const playButton = document.querySelector('.video-play-button');

    function playVideo(videoId) {
      pauseOtherVideos(videoId);
      document.getElementById(videoId).play();
      playButton.style.display = 'none';
    }

    videoContainers.forEach((container) => {
      const playButton = container.querySelector('.video-play-button');
      let pauseButton = container.querySelector('.video-pause-button');
      const video = container.querySelector('video');

      playButton.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          playButton.style.display = 'none';
          pauseButton.style.display = 'flex';
        } else {
          video.pause();
          playButton.style.display = 'flex';
          pauseButton.style.display = 'none';
        }
      });

      pauseButton?.addEventListener('click', function () {
        video.pause();
        playButton.style.display = 'flex';
        pauseButton.style.display = 'none';
      });

      video.addEventListener('play', function () {
        playButton.style.display = 'none';
        pauseButton.style.display = 'flex';
        pauseOtherVideos(video.id);
      });

      video.addEventListener('pause', function () {
        playButton.style.display = 'flex';
        pauseButton.style.display = 'none';
      });

      video.addEventListener('ended', function () {
        playButton.style.display = 'flex';
        pauseButton.style.display = 'none';
      });
    });

    function pauseOtherVideos(currentVideoId) {
      const allVideos = document.querySelectorAll('video');
      allVideos.forEach((video) => {
        if (video.id !== currentVideoId) {
          video.pause();
        }
      });
    }

    if (window.innerWidth > 768) {
      // Add Drift zoom functionality
      if (typeof Drift === 'function') {
        const driftImages = document.querySelectorAll('.drift-zoom-image');
        driftImages.forEach((img) => {
          new Drift(img, {
            paneContainer: document.querySelector('body'),
            inlinePane: false,
            containInline: true,
            hoverBoundingBox: true,
            zoomFactor: 2,
            touchDelay: 500,
            inlineOffsetY: -85,
            inlineOffsetX: -85,
          });
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-similar"] && !window.DesignMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(productRecommendationsSection);
    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          const container = document.getElementById('product-recommendation-container');
          const leftArrow = document.querySelector('#leftArrowProducts');
          const rightArrow = document.querySelector('#rightArrowProducts');
          const cardWidth = 294 + 16; // card width + margin-right
          let currentPosition = 0;

          function updateSliderPosition() {
            container.style.transform = `translateX(${currentPosition}px)`;
          }

          leftArrow.addEventListener('click', () => {
            currentPosition = Math.min(currentPosition + cardWidth, 0);
            updateSliderPosition();
          });

          rightArrow.addEventListener('click', () => {
            const containerWidth = container.offsetWidth;
            const scrollWidth = container.scrollWidth;
            const maxScroll = scrollWidth - containerWidth;
            currentPosition = Math.max(currentPosition - cardWidth, -maxScroll);
            updateSliderPosition();
          });

          // Refresh Yotpo widgets
          if (typeof yotpo !== 'undefined') {
            yotpo.refreshWidgets();
          } else {
            console.warn('Yotpo is not defined. Make sure Yotpo script is loaded properly.');
          }
        }

        yotpoWidgetsContainer.initWidgets();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["step-scroller"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const target = document.getElementById('target');
    const stepScroller = document.getElementById('step-scroller');
    let isLocked = false;
    let lastScrollY = window.scrollY;
    let targetTop = 0;
    let hasReachedStep3 = false;

    const isAtFirstStep = () => {
      return stepScroller.scrollTop === 0;
    };

    const enableStepScroller = () => {
      stepScroller.style.overflow = 'scroll';
      stepScroller.style.position = 'relative';
    };

    const disableStepScroller = () => {
      stepScroller.style.overflow = 'hidden';
      stepScroller.style.position = 'relative';
    };

    const checkIfReachedStep3 = () => {
      const scrollHeight = stepScroller.scrollHeight;
      const scrollTop = stepScroller.scrollTop;
      const clientHeight = stepScroller.clientHeight;

      if (Math.abs(scrollHeight - (scrollTop + clientHeight)) < 5) {
        hasReachedStep3 = true;
        unlockScroll();
        disableStepScroller();
        document.body.style.overflow = '';
      }
      return hasReachedStep3;
    };

    const lockScroll = () => {
      if (!isLocked && !hasReachedStep3) {
        targetTop = window.scrollY;
        document.body.classList.add('locked');
        document.body.style.top = `-${targetTop}px`;
        isLocked = true;
      }
    };

    const unlockScroll = () => {
      if (isLocked) {
        document.body.classList.remove('locked');
        document.body.style.top = '';
        window.scrollTo(0, targetTop);
        isLocked = false;
      }
    };

    const handleScroll = (e) => {
      const rect = target.getBoundingClientRect();
      const topEdge = rect.top;
      const currentScrollY = window.scrollY;
      const isScrollingUp = currentScrollY < lastScrollY;

      if (hasReachedStep3) {
        // Re-enable step-scroller when scrolling up and near its position
        if (isScrollingUp && topEdge > -100 && topEdge < window.innerHeight) {
          enableStepScroller();
          hasReachedStep3 = false;
        } else {
          disableStepScroller();
        }
        unlockScroll();
      } else {
        checkIfReachedStep3();

        if (isScrollingUp && isAtFirstStep()) {
          unlockScroll();
        } else if (isScrollingUp) {
          unlockScroll();
        } else if (topEdge <= 0 && !hasReachedStep3 && !isScrollingUp && !isAtFirstStep()) {
          lockScroll();
        } else if (topEdge > 0) {
          unlockScroll();
        }
      }

      lastScrollY = currentScrollY;
    };

    // Wheel event handler
    document.addEventListener(
      'wheel',
      (e) => {
        if (hasReachedStep3) {
          const rect = target.getBoundingClientRect();
          if (e.deltaY < 0 && rect.top > -100 && rect.top < window.innerHeight) {
            enableStepScroller();
            hasReachedStep3 = false;
          }
          return;
        }

        if (isLocked && !e.target.closest('#step-scroller')) {
          if (isAtFirstStep() && e.deltaY < 0) {
            return;
          }
          e.preventDefault();
          e.stopPropagation();
        }
      },
      { passive: false }
    );

    // Touch event handling
    let touchStartY = 0;
    document.addEventListener(
      'touchstart',
      (e) => {
        touchStartY = e.touches[0].clientY;
      },
      { passive: true }
    );

    document.addEventListener(
      'touchmove',
      (e) => {
        if (hasReachedStep3) {
          const rect = target.getBoundingClientRect();
          const touchY = e.touches[0].clientY;
          const isScrollingUp = touchY > touchStartY;

          if (isScrollingUp && rect.top > -100 && rect.top < window.innerHeight) {
            enableStepScroller();
            hasReachedStep3 = false;
          }
          return;
        }

        if (isLocked && !e.target.closest('#step-scroller')) {
          const touchY = e.touches[0].clientY;
          const isScrollingUp = touchY > touchStartY;

          if (isAtFirstStep() && isScrollingUp) {
            return;
          }

          if (!isScrollingUp) {
            e.preventDefault();
          }
        }
      },
      { passive: false }
    );

    stepScroller.addEventListener(
      'scroll',
      () => {
        if (!hasReachedStep3) {
          checkIfReachedStep3();
        }
      },
      { passive: true }
    );

    window.addEventListener('scroll', handleScroll, { passive: true });
    stepScroller.addEventListener('scroll', handleScroll, { passive: true });

    // Initial check
    checkIfReachedStep3();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["step-slider"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('#step-slider', {
      direction: 'horizontal',
      loop: true,
      slidesPerView: 1,
      spaceBetween: 50,
      mousewheel: false,
      disabledClass: 'opacity-30 pointer-events-none',
      navigation: {
        nextEl: '.next-step',
        prevEl: '.prev-step',
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Mobile Accordions
    const mobileAccordions = document.getElementById('mobile-accordions');
    if (mobileAccordions) {
      const mobileButtons = mobileAccordions.querySelectorAll('#mobile-accordions button');

      mobileButtons.forEach((button, index) => {
        // Assign unique IDs for accessibility
        const contentId = `mobile-accordion-content-${index + 1}`;
        button.setAttribute('id', `mobile-accordion-button-${index + 1}`);
        button.setAttribute('aria-controls', contentId);

        button.addEventListener('click', () => {
          const isExpanded = button.getAttribute('aria-expanded') === 'true';
          const content = document.getElementById(contentId);

          // Close all accordions
          mobileButtons.forEach((btn) => {
            const btnContent = document.getElementById(btn.getAttribute('aria-controls'));
            btn.setAttribute('aria-expanded', 'false');
            const span = btn.querySelector('span');
            if (span) {
              span.textContent = '+';
            }
            if (btnContent) {
              btnContent.classList.add('hidden');
            }
          });

          // Toggle current accordion
          if (!isExpanded) {
            button.setAttribute('aria-expanded', 'true');
            const span = button.querySelector('span');
            if (span) {
              span.textContent = '-';
            }
            if (content) {
              content.classList.remove('hidden');
            }
          }
        });

        // Enable keyboard navigation for accordions
        button.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            button.click();
          }
        });
      });
    }

    // Desktop Tabs
    const desktopTabs = document.querySelector('.hidden.lg\\:block');
    if (desktopTabs) {
      const tabButtons = desktopTabs.querySelectorAll('[role="tab"]');
      const tabPanels = desktopTabs.querySelectorAll('[role="tabpanel"]');

      tabButtons.forEach((button, index) => {
        // Assign unique IDs for accessibility
        const panelId = `tab-pane-desktop-${index + 1}`;
        button.setAttribute('id', `tab-desktop-button-${index + 1}`);
        button.setAttribute('aria-controls', panelId);
        if (index === 0) {
          button.setAttribute('tabindex', '0');
        } else {
          button.setAttribute('tabindex', '-1');
        }

        button.addEventListener('click', () => {
          // Deactivate all tabs
          tabButtons.forEach((btn) => {
            btn.classList.remove('border-brand-red');
            btn.setAttribute('aria-selected', 'false');
            btn.setAttribute('tabindex', '-1');
          });
          tabPanels.forEach((panel) => {
            panel.classList.add('hidden');
          });

          // Activate clicked tab
          button.classList.add('border-brand-red');
          button.setAttribute('aria-selected', 'true');
          button.setAttribute('tabindex', '0');

          // Show the selected tab content
          tabPanels[index].classList.remove('hidden');
        });

        // Enable keyboard navigation for tabs
        button.addEventListener('keydown', (e) => {
          let newIndex = index;
          if (e.key === 'ArrowRight') {
            newIndex = (index + 1) % tabButtons.length;
            tabButtons[newIndex].focus();
          } else if (e.key === 'ArrowLeft') {
            newIndex = (index - 1 + tabButtons.length) % tabButtons.length;
            tabButtons[newIndex].focus();
          } else if (e.key === 'Home') {
            tabButtons[0].focus();
          } else if (e.key === 'End') {
            tabButtons[tabButtons.length - 1].focus();
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellness-hub-bar"] && !window.DesignMode) return;
  try {
    
  var wellnessBarSwiper = new Swiper('.wellnessBarSwiper', {
    spaceBetween: 10,
    loop: true,
    breakpoints: {
      0: {
        slidesPerView: 1.5
      },
      800: {
        slidesPerView: 2
      },
      1300: {
        slidesPerView: 3
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
